import React, { PropsWithChildren, useContext, useState } from "react";

const NOP = () => {};

export const UXContext = React.createContext<{
  useRipple: boolean;
  setUseRipple: (b: boolean) => void;
}>({
  useRipple: true,
  setUseRipple: NOP,
});

export const UXContextProvider = (
  props: PropsWithChildren<{ useRipple?: boolean } | undefined>
) => {
  const [useRipple, setUseRipple] = useState(props.useRipple ?? true);

  return (
    <UXContext.Provider
      value={{
        useRipple,
        setUseRipple,
      }}
    >
      {props.children}
    </UXContext.Provider>
  );
};

export function useUXContext() {
  return useContext(UXContext);
}
